module.exports = __webpack_public_path__ + "media/social-media.b20b4bc2.mp4";